var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"stepper"},[_c('v-col',[_c('Stepper7')],1)],1),_c('v-row',[_c('div',{staticClass:"titulo"},[_c('Titulo',{attrs:{"Titulo":"Proceso de pago"}})],1)]),_c('div',[_c('OpenPay',{attrs:{"boletos_ida":_vm.boletos_ida,"boletos_vuelta":_vm.boletos_vuelta}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }